import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { LINKS, relPath } from '../../../../Routs/config'
import ProblemTeudotMain from './ProblemTeudotMain'
import ProblemsTeudotCreate from './Create/ProblemsTeudotCreate'
import { ProblemStateProvider } from './context/ProblemStateManager'


const ProblemTeudotIndex = () => {
  return (
    <ProblemStateProvider>
      <Routes>
        <Route
          index
          element={<ProblemTeudotMain/>}
        />
        <Route
          path={relPath(LINKS.teudotProblems.list.create, LINKS.teudotProblems.list.mainUrl)}
          element={<ProblemsTeudotCreate/>}
        />
      </Routes>
    </ProblemStateProvider>
  )
}

export default ProblemTeudotIndex